// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3Ro3q","title":"Images90_title__13Z5-","images":"Images90_images__A7moG"};